import { useRouter } from 'next/router';

interface NoPingAppVideoProps {
  className?: string;
}

export function NoPingAppVideo({ className = 'h-auto w-full' }: NoPingAppVideoProps) {
  const { locale } = useRouter();
  const videoSrc = locale === 'pt' ? '/assets/video/trial/pc-client-pt-br.mp4' : '/assets/video/trial/pc-client-en.mp4';

  return (
    <video key={locale} autoPlay loop muted playsInline aria-hidden='true' className={className}>
      <source src={videoSrc} type='video/mp4' />
    </video>
  );
}
